import {
  Box,
  Button,
  ButtonProps,
  CollectionPreferences,
  Header,
  NonCancelableCustomEvent,
  SpaceBetween,
} from '@amzn/awsui-components-core';
import React, { ReactNode } from 'react';
import { getHeaderCounterText, getServerHeaderCounterText } from '../../api/UtilsApi';
import constants from '../../common/constants';
interface TableHeaderProps {
  title?: React.ReactNode | string;
  description?: string;
  selectedItems?: any[];
  totalItems?: any[];
  actionButtons?: any;
  counter?: string;
  serverSide?: boolean;
  info?: React.ReactNode;
}

interface TablePreferencesProps {
  preferences: any;
  // @ts-expect-error TS7006 - strict migration
  setPreferences: (detail) => void;
  disabled?: boolean;
  visibleContentPreference?: any;
  // @ts-expect-error TS7006 - strict migration
  customPreference?: (value, setValue) => ReactNode;
}

export const TableNoMatchState = (props: {
  onClearFilter?: (event: NonCancelableCustomEvent<ButtonProps.ClickDetail>) => void;
}) => (
  <Box textAlign="center" margin={{ vertical: 's' }}>
    <b>No matches</b>
    <Box variant="p" margin={{ bottom: 'xs' }}>
      We can't find a match.
    </Box>
    <Button onClick={props.onClearFilter}>Clear filter</Button>
  </Box>
);

export const TableEmptyState = () => (
  <Box margin={{ vertical: 'xs' }} textAlign="center" color="inherit">
    <SpaceBetween size="xxs">
      <Box variant="p">No records were found.</Box>
    </SpaceBetween>
  </Box>
);

function getCounter(props: TableHeaderProps) {
  if (props.counter) {
    return props.counter;
  }
  if (!props.totalItems) {
    return null;
  }
  if (props.serverSide) {
    // @ts-expect-error TS2345 - strict migration
    return getServerHeaderCounterText(props.totalItems, props.selectedItems);
  }
  return getHeaderCounterText(props.totalItems, props.selectedItems);
}

export const TableHeader = (props: TableHeaderProps) => {
  return (
    <Header
      variant="h3"
      counter={getCounter(props)}
      description={props.description}
      actions={props.actionButtons}
      info={props.info}
    >
      {props.title}
    </Header>
  );
};

export const DEFAULT_PAGE_SIZE_OPTIONS = [
  { value: 5, label: '5' },
  { value: 10, label: '10' },
  { value: 25, label: '25' },
  { value: 50, label: '50' },
  { value: 100, label: '100' },
  { value: 200, label: '200' },
  { value: 500, label: '500' },
];

export const CUSTOM_PREFERENCE_OPTIONS = [
  { value: 'table', label: 'Table' },
  { value: 'cards', label: 'Cards' },
];

export const DEFAULT_PREFERENCES = {
  pageSize: 30,
  wrapLines: false,
  // @ts-expect-error TS2532 - strict migration
  custom: CUSTOM_PREFERENCE_OPTIONS[0].value,
};

export const Preferences = (preferencesProps: TablePreferencesProps) => (
  <CollectionPreferences
    title={constants.PREFERENCES}
    cancelLabel={constants.CANCEL_BUTTON_TEXT}
    confirmLabel={constants.CONFIRM_BUTTON_TEXT}
    disabled={!!preferencesProps.disabled}
    preferences={preferencesProps.preferences}
    onConfirm={({ detail }) => preferencesProps.setPreferences(detail)}
    pageSizePreference={{
      title: constants.TABLE_PAGE_SELECTOR_MESSAGE,
      options: DEFAULT_PAGE_SIZE_OPTIONS,
    }}
    wrapLinesPreference={{
      label: constants.TABLE_WRAPLINES_LABEL,
      description: constants.TABLE_WRAPLINES_DESCRIPTION,
    }}
    visibleContentPreference={preferencesProps.visibleContentPreference}
    customPreference={preferencesProps.customPreference}
  />
);
